/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./TheCurrentUserAvatar.vue?vue&type=template&id=438da721&scoped=true"
import script from "./TheCurrentUserAvatar.ts?vue&type=script&lang=ts&external"
export * from "./TheCurrentUserAvatar.ts?vue&type=script&lang=ts&external"
import style0 from "./TheCurrentUserAvatar.vue?vue&type=style&index=0&id=438da721&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438da721",
  null
  
)

export default component.exports